/* SliderNavigationArrowsTemplate */
import { FunctionalComponent, h } from '@stencil/core'; // eslint-disable-line @typescript-eslint/no-unused-vars
import { SliderComponent } from '../cwc-slider';

/**
 * Definition of  parameters that the template needs to work.
 */
interface NavigationArrowsTemplateProps {
  /**
   * The class instance that provides controller functionality for the template
   */
  controller: SliderComponent;
  // Specify parameters that are required to be passed down to the template here.
}

const NavigationArrowsTemplate: FunctionalComponent<NavigationArrowsTemplateProps> = ({ controller }) => (
  <div class="navigation-arrows" data-visible={controller.arrows}>
    <div
      onClick={() => controller.slideToPrevious()}
      data-enabled={controller.canSlideToPrevious()}
      onFocusout={() =>
        !controller.canSlideToPrevious() &&
        (controller.element.querySelector('[slot="button-next"]') as HTMLElement).focus()
      }
      class="button-prev"
    >
      <slot name="button-prev" />
    </div>

    <div
      onClick={() => controller.slideToNext()}
      data-enabled={controller.canSlideToNext()}
      onFocusout={() =>
        !controller.canSlideToNext() &&
        (controller.element.querySelector('[slot="button-prev"]') as HTMLElement).focus()
      }
      class="button-next"
    >
      <slot name="button-next" />
    </div>
  </div>
);

export default NavigationArrowsTemplate;
